import React from 'react';
import { CellProps } from './CellProps';

const grey = { color: '#CACACA' };

const Field = ({ children, style }: CellProps) => {
  let actualStyle;
  if (style) {
    actualStyle = style;
  } else {
    actualStyle = grey;
  }

  return <div style={actualStyle}>{children}</div>;
};

export default Field;
